import { TrainingMethod } from '../types';
import { Result } from './result.model';

export class SegmentationResult extends Result {
    workflowResultId: string;
    datasetId?: string;
    trainingWorkflowResultId?: string;
    trainingShareId?: string;
    trainingType?: TrainingMethod;
    mlVersion?: number;
    applicationId?: string;
    applicationName?: string;
    applicationUserId?: string;
    customerGroup: string;

    constructor(resultModel?: SegmentationResult) {
        if (resultModel != null) {
            super(resultModel);
            this.workflowResultId = resultModel.workflowResultId;
            this.datasetId = resultModel.datasetId;
            this.trainingWorkflowResultId = resultModel.trainingWorkflowResultId;
            this.trainingShareId = resultModel.trainingShareId;
            this.mlVersion = resultModel.mlVersion;
            this.applicationId = resultModel.applicationId;
            this.applicationName = resultModel.applicationName;
            this.applicationUserId = resultModel.applicationUserId;
            this.customerGroup = resultModel.customerGroup;
        }
    }
}
